import React, { useState } from "react";

import MainLayout from "../layouts/Main";
import SchoolForm from "../views/forms/School";
import { ModuleFeatures } from "../sub_components/ModuleFeatures";

import useGetSchools from "../../hooks/schools/useGetSchools";

import { ISelectedData, ITreeItemES } from "../../interfaces/tree";

const SchoolsPage = () => {
    const [selected, setSelected] = useState<ISelectedData | null>(null);
    const [expanded, setExpanded] = useState<ITreeItemES[]>([]);

    const { data: schools } = useGetSchools();

    return (
        <MainLayout
            schoolsData={{
                schools: schools ?? [],
                selected: selected,
                setSelected: setSelected,
                expanded: expanded,
                setExpanded: setExpanded,
            }}
        >
            <div className="immersion_admin__schools__page_view">
                {selected?.level === 0 &&
                    <div className="immersion_admin__schools__page_view__form_and_features">
                        <SchoolForm
                            schoolData={selected.data}
                            selected={selected}
                            setSelected={setSelected}
                            expanded={expanded}
                            setExpanded={setExpanded}
                        />
                        {!!selected?.data?.id && <ModuleFeatures schoolId={selected.data.id} />}
                    </div>
                }
                {!selected &&
                    <div className="immersion_admin__schools_page__no_selection">
                        <br /><br />
                        <h3 className="dark_color">Manage Schools</h3>
                        <br />
                        <p className="wt_500">Add/Update the schools. Manage users and schools of the school.</p>
                        <p className="wt_500">Select/Add the school to proceed.</p>
                    </div>
                }
            </div>
        </MainLayout>
    );
};

export default SchoolsPage;
